import { FC } from 'react';
import { CellContainer } from '@/_components';
import { CellCheckboxProps } from './CellCheckbox.types';

export const CellCheckbox: FC<CellCheckboxProps> = ({ children, isHeader }) => {
  return (
    <CellContainer width={32} isHeader={isHeader}>
      {children}
    </CellContainer>
  );
};
